import React from 'react';

import {WidthItem} from 'src/components/width-item';
import {GRANT_STATUS_CAPTIONS} from 'src/modules/entitlements/constants';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Highlight, getIndexesOfMatches} from '@pb/kit-component-highlight';
import {Icon, Icons} from '@pb/kit-component-icon';


import type {SuggestionItem} from '../../types';

type Props = {
    suggestion: SuggestionItem,
    normalizedQuery: string,
    isSelected: boolean,
};

const getHighlightedName = (name: string, normalizedQuery: string) => {
    if (!normalizedQuery) {
        return name;
    }

    const matchedChunks = getIndexesOfMatches(name.toLowerCase(), normalizedQuery);

    if (!matchedChunks.length) {
        return name;
    }

    return (
        <Highlight
            text={name}
            matchedChunks={matchedChunks}
        />
    );
};

export const PresetSuggestItem = ({suggestion, normalizedQuery, isSelected}: Props) => (
    <AutosuggestItem value={suggestion}>
        {itemProps => (
            <Group justify="space-between" alignItems="center">
                <Group alignItems="center">
                    <WidthItem width={150}>
                        <EllipsisTextHint title={suggestion.name}>
                            {itemProps.highlighted
                                ? suggestion.name
                                : getHighlightedName(suggestion.name, normalizedQuery)}
                        </EllipsisTextHint>
                    </WidthItem>
                    {suggestion.relations.length > 1
                        ? <WidthItem width={32}>{` (${suggestion.relations.length})`}</WidthItem>
                        : <WidthItem width={32}/>}
                    {suggestion.grant
                        ? <b>{GRANT_STATUS_CAPTIONS[suggestion.grant.status]}</b>
                        : null}
                </Group>
                {isSelected ? <Icon type={Icons.CHECK}/> : null}
            </Group>
        )}
    </AutosuggestItem>
);
